import { PropsWithChildren } from 'react'

import { DndContext } from '@dnd-kit/core'

import { pick } from '../../../../utils/object'
import { useDraggableModalStore } from '../hooks'

export const DraggableModalDndContext = ({ children }: PropsWithChildren) => {
  const { id, setCoordinates } = useDraggableModalStore(state =>
    pick(state, ['id', 'setCoordinates'])
  )
  return (
    <DndContext
      id={id}
      onDragEnd={({ delta }) => {
        setCoordinates(({ x, y }) => {
          return {
            x: x + delta.x,
            y: y + delta.y
          }
        })
      }}
    >
      {children}
    </DndContext>
  )
}
